function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:url(#pure_to_pure);}"), /*#__PURE__*/React.createElement("linearGradient", {
  id: "pure_to_pure",
  x1: 108.15,
  y1: 250,
  x2: 349.99,
  y2: 250,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#1fc3f3"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#4cbfac"
})));

var _ref3 = /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M240.51,436l-.62,0a8.6,8.6,0,0,1-7.95-7.76l-29-296.72L162.72,334.81a8.61,8.61,0,0,1-16.77.54l-16.2-60.93-5.83,21.22a8.61,8.61,0,0,1-8.3,6.33h-87a8.62,8.62,0,0,1,0-17.23h80.45l12.52-45.6a8.6,8.6,0,0,1,8.3-6.33h0a8.62,8.62,0,0,1,8.29,6.4L153,295l44.35-224.1A8.72,8.72,0,0,1,206.25,64a8.62,8.62,0,0,1,8.15,7.76l29.77,304.68,34.54-140.55a8.27,8.27,0,0,1,8.43-6.56,8.61,8.61,0,0,1,8.33,6.69L318,334.9l19.16-64A8.61,8.61,0,0,1,353,269.3l9.37,17.55h109a8.61,8.61,0,1,1,0,17.22H357.25a8.62,8.62,0,0,1-7.59-4.55l-2-3.66-22.53,75.27a8.81,8.81,0,0,1-8.54,6.14,8.61,8.61,0,0,1-8.11-6.69l-21.75-95.33-37.9,154.22A8.6,8.6,0,0,1,240.51,436Z"
});

var SvgIconPulseOx = (_ref) => {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 500 500",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIconPulseOx, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/Icon_pulseOx.5ded7e49.svg";
export { ForwardRef as ReactComponent };